import { Component, OnInit, ViewEncapsulation, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import { isNullOrUndefined } from 'util';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class BreadCrumbService {

  breadCrumbSubject = new Subject<MenuItem[]>();

  constructor() { }

  public createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      let routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const label = child.snapshot.data[BreadCrumbComponent.ROUTE_DATA_BREADCRUMB];
      const isVisible = child.snapshot.data[BreadCrumbComponent.ROUTE_DATA_BREADCRUMB_VISIBLE];
      if (isVisible === false) {
        return null;
      }

      if (!isNullOrUndefined(label)) {
        breadcrumbs.push({ label, routerLink: [url] });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }
}

@Component({
  selector: 'app-breadcrumb',
  template: `<p-breadcrumb [model]="menuItems" *ngIf="menuItems"></p-breadcrumb>`,
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .ui-breadcrumb{
        border-top: 0px !important;
        border-right: 0px !important;
        border-left: 0px !important;
        font-size: 13px !important;
        padding-left: 0px !important;
        margin: 15px !important;
    }
    
    .ui-corner-all {
        border-radius: 0px !important;
    }
    .ui-menuitem-text{
      cursor:pointer;
    }
  `]
})
export class BreadCrumbComponent implements OnInit {

  menuItems: MenuItem[];
  static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  static readonly ROUTE_DATA_BREADCRUMB_VISIBLE = "breadcrumbVisible";

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    protected breadCrumbService: BreadCrumbService, private location: Location) { }

  ngOnInit(): void {
    this.init();
    this.breadCrumbService.breadCrumbSubject.subscribe((items) => {
      this.menuItems = items;
    })
  }

  init() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.menuItems = this.breadCrumbService.createBreadcrumbs(this.activatedRoute.root));
  }
}
